import { createSlice } from '../../../common/redux.Interface.Reducer'
import { GlobalFeatureNameSpaceNotary } from '../../../common/globalNotary'
import {
  consumerDataFetchSuccess,
  providerDataFetchSuccess,
  consumerDataFetchFailure,
  accountDetailFetch,
  lineChartDataByDateFetch,
  lineChartDataByLocationFetch,
  commentByDateFetch,
  validationErrorChange
} from './actions'

const initialState = { loading: true }

const dynamictabsSlice = createSlice({
  name: GlobalFeatureNameSpaceNotary.DYNAMIC_TABS,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(consumerDataFetchSuccess, (state, action) => {
      const newState = action.payload
      const loading = action.tabName === 'tab3'
      state = { ...state, ...newState, loading, error: null }
      return state
    })

    builder.addCase(providerDataFetchSuccess, (state, action) => {
      const newState = action.payload
      state = { ...state, ...newState, loading: false, error: null }
      return state
    })

    builder.addCase(validationErrorChange, (state, action) => {
      const newState = action.payload

      state = { ...state, loading: false, validationErrors: newState }
      return state
    })

    builder.addCase(consumerDataFetchFailure, (state, action) => {
      const newState = action.payload
      //alert(action.type)

      return { ...state, error: newState, loading: false }
    })

    builder.addCase(accountDetailFetch.pending, (state, action) => {
      return { ...state, loading: true, error: null }
    })

    builder.addCase(accountDetailFetch.fulfilled, (state, action) => {
      //alert(action.type)
      const newState = action.payload
      return { ...state, accountDetail: newState, loading: false, error: null }
    })

    builder.addCase(accountDetailFetch.rejected, (state, action) => {
      //alert(action.type)

      const newState = action.payload
      return { ...state, error: newState, loading: false }
    })

    builder.addCase(lineChartDataByDateFetch.pending, (state, action) => {
      //alert(action.type)

      return { ...state, loading: true, error: null }
    })

    builder.addCase(lineChartDataByDateFetch.fulfilled, (state, action) => {
      //alert(action.type)

      const newState = action.payload
      return { ...state, chartData: newState, loading: false, error: null }
    })

    builder.addCase(lineChartDataByDateFetch.rejected, (state, action) => {
      //alert(action.type)

      const newState = action.payload
      return { ...state, error: newState, loading: false }
    })

    builder.addCase(lineChartDataByLocationFetch.pending, (state, action) => {
      //alert(action.type)

      return { ...state, loading: true, error: null }
    })

    builder.addCase(lineChartDataByLocationFetch.fulfilled, (state, action) => {
      //alert(action.type)

      const newState = action.payload
      return { ...state, chartData: newState, loading: false, error: null }
    })

    builder.addCase(lineChartDataByLocationFetch.rejected, (state, action) => {
      //alert(action.type)

      const newState = action.payload
      return { ...state, error: newState, loading: false }
    })

    builder.addCase(commentByDateFetch.pending, (state, action) => {
      //alert(action.type)

      return { ...state, loading: true, error: null }
    })

    builder.addCase(commentByDateFetch.fulfilled, (state, action) => {
      //alert(action.type)

      const newState = action.payload
      return { ...state, commentData: newState, loading: false, error: null }
    })

    builder.addCase(commentByDateFetch.rejected, (state, action) => {
      //alert(action.type)

      const newState = action.payload
      return { ...state, error: newState, loading: false }
    })
  }
})

export default dynamictabsSlice.reducer
